//
//
//
//
//
//
//

import { SUCCESS_CODE } from '@/service/httpCode'
import { getAppInfo } from '@/js/utils'
export default {
  props: {
    needSendCode: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    sendVertificationCode: {
      type: Function,
      required: true
    },
    theme: {
      type: String,
      default: '1'
    }
  },
  created() {
    this.isAndroid = getAppInfo().system === 'android'
  },
  data() {
    return {
      sendBtnText: '发送验证码',
      isBtnDisabled: false,
      isAndroid: false
    }
  },
  watch: {
    needSendCode: {
      handler(val) {
        if (val) {
          this.sendVcode()
        }
      },
      immediate: true
    }
  },
  methods: {
    resetTimer() {
      clearInterval(this.timer)
      this.sendBtnText = '重新发送'
      this.isBtnDisabled = false
    },
    sendVcode() {
      this.sendVertificationCode().then(result => {
        if (result !== SUCCESS_CODE) {
          this.resetTimer()
        }
      })

      clearInterval(this.timer)
      this.isBtnDisabled = true
      let second = 60
      this.sendBtnText = `${second}s重发`
      this.timer = setInterval(() => {
        this.sendBtnText = `${--second}s重发`
        if (second < 0) {
          this.resetTimer()
        }
      }, 1000)
    }
  }
}
